import { useTranslation } from "react-i18next";
import "./index.scss";

function UserRankingComponent() {
  const { t } = useTranslation();
  return (
    <div className="user-ranking">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1141_2836)">
          <path
            d="M10.5587 11.2132L11.2904 10.0259L12.6107 9.57563L12.757 8.18884L13.7504 7.21088L13.2781 5.89819L13.7504 4.58547L12.757 3.6075L12.6108 2.22075L11.2904 1.77044L10.5587 0.583156L9.17483 0.75025L7.99923 0L6.82364 0.750313L5.43977 0.583219L4.70811 1.77047L3.38773 2.22078L3.24145 3.60753L2.24805 4.5855L2.72036 5.89822L2.24805 7.21094L3.24142 8.18888L3.3877 9.57566L4.70808 10.026L5.43973 11.2132L6.82364 11.0462L7.99923 11.7964L9.17483 11.0462L10.5587 11.2132ZM3.95458 5.89822C3.95458 3.668 5.76902 1.85356 7.99923 1.85356C10.2295 1.85356 12.0439 3.668 12.0439 5.89822C12.0439 8.12844 10.2295 9.94287 7.99923 9.94287C5.76902 9.94287 3.95458 8.12844 3.95458 5.89822Z"
            fill="black"
          />
          <path
            d="M7.99914 2.79163C6.28617 2.79163 4.89258 4.18522 4.89258 5.89819C4.89258 7.61116 6.28617 9.00475 7.99914 9.00475C9.71211 9.00475 11.1057 7.61116 11.1057 5.89819C11.1057 4.18522 9.71211 2.79163 7.99914 2.79163Z"
            fill="black"
          />
          <path
            d="M6.60275 12.0178L4.9565 12.2165L4.08672 10.805L3.79103 10.7042L2.51562 14.6907L4.81172 14.5644L6.60812 16L7.66525 12.6959L6.60275 12.0178Z"
            fill="black"
          />
          <path
            d="M11.9125 10.8051L11.0427 12.2165L9.39648 12.0178L8.33398 12.6959L9.39111 16L11.1875 14.5644L13.4836 14.6907L12.2082 10.7042L11.9125 10.8051Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1141_2836">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span className="txt font-yumincho">{t("userInfo.rank.regular")}</span>
    </div>
  );
}

export default UserRankingComponent;
